module.exports = __webpack_public_path__ + "img/hubspot-screen.1cd2a735.jpg";